var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimationDotsLayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    id: "layer1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.257 85.472C-.008 83.374-1.562 79.498-.823 75.302L10.512 16.393C11.25 12.2 14.172 8.323 18.175 6.225 22.176 4.129 26.651 4.129 29.917 6.225L75.738 35.679C79 37.777 80.556 41.654 79.817 45.85 79.077 50.044 76.155 53.92 72.152 56.018L14.995 85.472C12.996 86.52 10.876 87.044 8.85 87.044 6.82 87.044 4.885 86.52 3.257 85.472Z",
    id: "path-2",
    clipPath: "url(#circle-opacity)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.073 83.816C16.377 82.084 15.094 78.882 15.704 75.417L25.064 26.77C25.675 23.306 28.087 20.105 31.393 18.372 34.697 16.641 38.393 16.641 41.09 18.372L78.929 42.696C81.624 44.428 82.909 47.63 82.298 51.095 81.687 54.558 79.274 57.76 75.968 59.492L28.767 83.816C27.116 84.682 25.365 85.114 23.692 85.114 22.016 85.114 20.418 84.682 19.073 83.816Z ",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.379 88.238C13.346 86.289 11.903 82.688 12.589 78.789L23.119 24.061C23.806 20.165 26.52 16.563 30.239 14.614 33.956 12.667 38.114 12.667 41.148 14.614L83.717 41.978C86.748 43.927 88.194 47.529 87.508 51.427 86.819 55.323 84.105 58.925 80.386 60.874L27.285 88.238C25.427 89.212 23.458 89.699 21.576 89.699 19.69 89.699 17.892 89.212 16.379 88.238Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.394 97.543C2.48 95.028.617 90.381 1.503 85.35L15.091 14.73C15.977 9.702 19.479 5.054 24.278 2.539 29.075.026 34.44.026 38.356 2.539L93.286 37.849C97.198 40.365 99.063 45.012 98.177 50.042 97.289 55.07 93.787 59.718 88.988 62.233L20.466 97.543C18.069 98.8 15.528 99.428 13.099 99.428 10.666 99.428 8.346 98.8 6.394 97.543Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#path-2",
    x: 10,
    y: 7,
    width: 36
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-opacity"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 0.01,
    id: "dotsVisibilityPath",
    stroke: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1-dots",
    clipPath: "url(#mask)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 0.8,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 4.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 7.3999999999999995,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 10.7,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 14,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 17.3,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 20.6,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 20.6,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 20.6,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 20.6,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 20.6,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 23.900000000000002,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 27.200000000000003,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 30.500000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 33.800000000000004,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 37.1,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 37.1,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 40.4,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 40.4,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 43.699999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 46.99999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 50.29999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 53.59999999999999,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 56.899999999999984,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 60.19999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 63.49999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 66.79999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 70.09999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 73.39999999999998,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 76.69999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 79.99999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 83.29999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 86.59999999999997,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 89.89999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 93.19999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3999999999999995,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.900000000000002,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.200000000000003,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.500000000000004,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.800000000000004,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.699999999999996,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.99999999999999,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.29999999999999,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59999999999999,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.899999999999984,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.19999999999998,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.49999999999998,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.79999999999998,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.09999999999998,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.39999999999998,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.69999999999997,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.99999999999997,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.29999999999997,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.59999999999997,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.89999999999996,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.19999999999996,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.49999999999996,
    cy: 96.49999999999996,
    r: 0.8,
    fill: "white",
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimationDotsLayer);
export default __webpack_public_path__ + "static/media/animation-dots-layer.45bc3b576aff7a28f999b1e5785a502a.svg";
export { ForwardRef as ReactComponent };